import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TelemarketingResponse, UsuarioResponse } from '../interfaces/telemarketing.interface';

@Injectable({
  providedIn: 'root'
})
export class TelemarketingService {
  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) { }

  getTelemarketing(): Observable<TelemarketingResponse> {
    return this.http.post<TelemarketingResponse>(`${this.apiUrl}OpcionesSolicitud/GetTelefono`, {
      limit: "9999"
    });
  }

  deleteTelemarketing(cvetelefonista: string): Observable<{success: boolean, data: boolean}> {
    return this.http.post<{success: boolean, data: boolean}>(`${this.apiUrl}Telemarketing/cmspa_telefoDelete`, {
      que: 0,
      tope: "",
      cmd: "",
      cvetelefonista: cvetelefonista,
      nombre: "",
      nivelseguridad: 0,
      numeroempleado: "",
      tipocontrato: "",
      rangO1: 0,
      comisioN1: 0,
      rangO2: 0,
      comisioN2: 0,
      rangO3: 0,
      comisioN3: 0,
      rangO4: 0,
      comisioN4: 0,
      comisionmayor: 0
    });
  }

  getUsuarios(): Observable<UsuarioResponse> {
    return this.http.post<UsuarioResponse>(`${this.apiUrl}UsuarsCS/Getcmspa_usua4V2`, {
      tope: "9999",
      usuario: ""
    });
  }

  createTelemarketing(data: { cvetelefonista: string, nombre: string, numeroempleado: string }): Observable<{success: boolean, data: boolean}> {
    return this.http.post<{success: boolean, data: boolean}>(`${this.apiUrl}Telemarketing/cmspa_telefoAdd`, {
      que: 1,
      tope: "",
      cmd: "",
      cvetelefonista: data.cvetelefonista,
      nombre: data.nombre,
      nivelseguridad: 0,
      numeroempleado: data.numeroempleado,
      tipocontrato: "",
      rangO1: 0,
      comisioN1: 0,
      rangO2: 0,
      comisioN2: 0,
      rangO3: 0,
      comisioN3: 0,
      rangO4: 0,
      comisioN4: 0,
      comisionmayor: 0
    });
  }

  getTelemarketingDetails(cvetelefonista: string): Observable<TelemarketingResponse> {
    return this.http.post<TelemarketingResponse>(`${this.apiUrl}Telemarketing/cmspa_telefoListDet`, {
      que: 5,
      tope: "",
      cmd: "",
      cvetelefonista: cvetelefonista,
      nombre: "",
      nivelseguridad: 0,
      numeroempleado: "",
      tipocontrato: "",
      rangO1: 0,
      comisioN1: 0,
      rangO2: 0,
      comisioN2: 0,
      rangO3: 0,
      comisioN3: 0,
      rangO4: 0,
      comisioN4: 0,
      comisionmayor: 0
    });
  }

  updateTelemarketing(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}Telemarketing/cmspa_telefoUpd`, payload);
  }
} 